import React, { useState } from 'react';
import { ConsentNotice } from '@/components/ConsentNotice';
import { Button } from '@/components/ui/button';
import { BarChart3 } from 'lucide-react';

const CONSENT_KEY = 'insul_analytics_consent';

const getStoredConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const AnalyticsConsentBanner = () => {
  const [choiceMade, setChoiceMade] = useState(() => getStoredConsent() !== null);

  if (choiceMade) return null;

  const decide = (accepted) => {
    try { localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'rejected'); } catch {}
    if (accepted && window.__insulInitAnalytics) {
      window.__insulInitAnalytics();
      window.posthog?.opt_in_capturing?.();
    }
    setChoiceMade(true);
  };

  return (
    <div
      data-testid="analytics-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] bg-white/95 backdrop-blur border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.08)] p-4"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <BarChart3 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
          <p className="text-sm text-muted-foreground">
            <ConsentNotice slot="cookie_banner">We'd like to use optional analytics to understand how the
            app is used and improve it. The app works fully without it, and you can change this
            choice anytime in your Profile settings.</ConsentNotice>
          </p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <Button
            data-testid="reject-analytics-btn"
            variant="outline"
            className="rounded-full"
            onClick={() => decide(false)}
          >
            Reject non-essential
          </Button>
          <Button
            data-testid="accept-analytics-btn"
            className="rounded-full bg-gradient-to-r from-primary to-emerald-500"
            onClick={() => decide(true)}
          >
            Accept analytics
          </Button>
        </div>
      </div>
    </div>
  );
};
